import { useEffect } from 'react'

/**
 * Custom hook to dynamically update mobile status bar color
 * Based on the current screen/route
 */
export function useStatusBarColor(currentPage: string) {
  useEffect(() => {
    // Determine status bar color based on current page
    let statusBarColor = '#0f172a' // Default: Dark slate-900

    // Home/Landing page gets orange brand color
    if (currentPage === 'home') {
      statusBarColor = '#f37021' // Orange brand color
    }
    // Share viewer and other immersive views stay dark
    else if (currentPage.startsWith('share-')) {
      statusBarColor = '#0f172a' // Dark slate-900
    }

    // Update theme-color meta tag for mobile browsers
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', statusBarColor)
    }

    // Update Apple mobile web app status bar (iOS Safari)
    const metaAppleStatusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')
    if (metaAppleStatusBar) {
      // Always use light-content (white text) for both orange and dark backgrounds
      if (currentPage === 'home') {
        metaAppleStatusBar.setAttribute('content', 'black-translucent')
      } else {
        metaAppleStatusBar.setAttribute('content', 'black-translucent')
      }
    }

    // Update Windows Phone color
    const metaMsApplication = document.querySelector('meta[name="msapplication-navbutton-color"]')
    if (metaMsApplication) {
      metaMsApplication.setAttribute('content', statusBarColor)
    }

    // Cleanup: Reset to dark on unmount (for consistency)
    return () => {
      const metaThemeColor = document.querySelector('meta[name="theme-color"]')
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', '#0f172a')
      }
    }
  }, [currentPage])
}
